import { render, staticRenderFns } from "./ListFixedPage.vue?vue&type=template&id=fb618bae&"
import script from "./ListFixedPage.vue?vue&type=script&lang=js&"
export * from "./ListFixedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports